<section class="perfil-form">
  <div class="cv-toolbar">
    <button type="button" class="btn-pdi" (click)="prepararImportacionPdi()">
      Integración con Portal del Investigador <span class="btn-plus" aria-hidden="true">+</span>
    </button>
  </div>

  <p class="pdi-status" *ngIf="importacionPendiente">
    <span class="pdi-check" aria-hidden="true"></span>
    Se cargaron datos desde PDI para revisión previa.
  </p>
  <p class="save-message" *ngIf="mensajeCv && !importacionPendiente">{{ mensajeCv }}</p>

  <div class="cv-preview-pdi" *ngIf="importacionPendiente">
    <h4>Vista previa importación PDI</h4>
    <p>{{ textoVistaPreviaPdi }}</p>
    <div class="cv-preview-acciones">
      <button type="button" class="btn-texto" (click)="confirmarImportacionPdi()">Confirmar <span class="btn-plus" aria-hidden="true">+</span></button>
      <button type="button" class="btn-texto" (click)="cancelarImportacionPdi()">Eliminar <span class="btn-plus" aria-hidden="true">+</span></button>
    </div>
  </div>

  <article class="acordeon" [class.abierto]="estaAbierto('estudios')">
    <button type="button" class="acordeon-cabecera" (click)="alternar('estudios')" [attr.aria-expanded]="estaAbierto('estudios')">
      <span>Estudios</span>
      <span class="acordeon-icono" aria-hidden="true"></span>
    </button>
    <div class="acordeon-cuerpo" *ngIf="estaAbierto('estudios')">
      <div class="perfil-grid">
        <label>
          Tipo de antecedente académico <span class="required-mark">*</span>
          <select [(ngModel)]="formularioCv.formacionAcademica.tipoAntecedente">
            <option value="">Seleccionar</option>
            <option *ngFor="let item of catalogoConValor(tiposAntecedente, formularioCv.formacionAcademica.tipoAntecedente)" [value]="item">{{ item }}</option>
          </select>
        </label>
        <label>
          Título / Grado / Especialización <span class="required-mark">*</span>
          <input type="text" [(ngModel)]="formularioCv.formacionAcademica.grado" placeholder="Texto de ejemplo" />
        </label>
        <label>
          Institución <span class="required-mark">*</span>
          <select [(ngModel)]="formularioCv.formacionAcademica.institucion">
            <option value="">Seleccionar</option>
            <option *ngFor="let item of catalogoConValor(instituciones, formularioCv.formacionAcademica.institucion)" [value]="item">{{ item }}</option>
          </select>
        </label>
        <label>
          País <span class="required-mark">*</span>
          <select [(ngModel)]="formularioCv.formacionAcademica.pais">
            <option value="">Seleccionar</option>
            <option *ngFor="let item of catalogoConValor(paises, formularioCv.formacionAcademica.pais)" [value]="item">{{ item }}</option>
          </select>
        </label>
        <label>
          Estado del estudio <span class="required-mark">*</span>
          <select [(ngModel)]="formularioCv.formacionAcademica.estado">
            <option value="">Seleccionar</option>
            <option value="en_curso">En curso</option>
            <option value="finalizado">Finalizado</option>
          </select>
        </label>
        <div class="fechas-par">
          <label>
            Fecha de inicio <span class="required-mark">*</span>
            <input type="date" [(ngModel)]="formularioCv.formacionAcademica.fechaInicio" />
          </label>
          <label>
            Fecha de término
            <input type="date" [(ngModel)]="formularioCv.formacionAcademica.fechaTermino" />
          </label>
        </div>
      </div>
      <p class="cv-lista-titulo" *ngIf="cvData.formacionAcademica.length">Registros en este bloque</p>
      <ul class="cv-lista" *ngIf="cvData.formacionAcademica.length">
        <li *ngFor="let item of cvData.formacionAcademica; let i = index">
          <span>{{ resumenEstudio(item) }}</span>
          <span class="cv-lista-acciones">
            <button type="button" class="btn-mini-link" (click)="editarRegistro('estudios', i)">Editar</button>
            <button type="button" class="btn-mini-link" (click)="eliminarRegistro('estudios', i)">Eliminar</button>
          </span>
        </li>
      </ul>
      <div class="acordeon-acciones split">
        <div class="acciones-izquierda">
          <button type="button" class="btn-texto" (click)="editarRegistro('estudios')">Editar <span class="btn-plus" aria-hidden="true">+</span></button>
          <button type="button" class="btn-texto" (click)="eliminarRegistro('estudios')">Eliminar <span class="btn-plus" aria-hidden="true">+</span></button>
        </div>
        <button type="button" class="btn-agregar" (click)="agregarRegistro('estudios')">{{ etiquetaAgregar('estudios') }} <span class="btn-plus" aria-hidden="true">+</span></button>
      </div>
    </div>
  </article>

  <article class="acordeon" [class.abierto]="estaAbierto('lineas')">
    <button type="button" class="acordeon-cabecera" (click)="alternar('lineas')" [attr.aria-expanded]="estaAbierto('lineas')">
      <span>Líneas de investigación</span>
      <span class="acordeon-icono" aria-hidden="true"></span>
    </button>
    <div class="acordeon-cuerpo" *ngIf="estaAbierto('lineas')">
      <div class="perfil-grid">
        <label>
          Línea de investigación <span class="required-mark">*</span>
          <input type="text" [(ngModel)]="formularioCv.lineasInvestigacion.linea" placeholder="Texto de ejemplo" />
        </label>
        <label>
          Disciplina / Área <span class="required-mark">*</span>
          <select [(ngModel)]="formularioCv.lineasInvestigacion.disciplinaArea">
            <option value="">Seleccionar</option>
            <option *ngFor="let item of catalogoConValor(disciplinas, formularioCv.lineasInvestigacion.disciplinaArea)" [value]="item">{{ item }}</option>
          </select>
        </label>
      </div>
      <p class="cv-lista-titulo" *ngIf="cvData.lineasInvestigacion.length">Registros en este bloque</p>
      <ul class="cv-lista" *ngIf="cvData.lineasInvestigacion.length">
        <li *ngFor="let item of cvData.lineasInvestigacion; let i = index">
          <span>{{ resumenLinea(item) }}</span>
          <span class="cv-lista-acciones">
            <button type="button" class="btn-mini-link" (click)="editarRegistro('lineas', i)">Editar</button>
            <button type="button" class="btn-mini-link" (click)="eliminarRegistro('lineas', i)">Eliminar</button>
          </span>
        </li>
      </ul>
      <div class="acordeon-acciones split">
        <div class="acciones-izquierda">
          <button type="button" class="btn-texto" (click)="editarRegistro('lineas')">Editar <span class="btn-plus" aria-hidden="true">+</span></button>
          <button type="button" class="btn-texto" (click)="eliminarRegistro('lineas')">Eliminar <span class="btn-plus" aria-hidden="true">+</span></button>
        </div>
        <button type="button" class="btn-agregar" (click)="agregarRegistro('lineas')">{{ etiquetaAgregar('lineas') }} <span class="btn-plus" aria-hidden="true">+</span></button>
      </div>
    </div>
  </article>

  <article class="acordeon" [class.abierto]="estaAbierto('experiencia')">
    <button type="button" class="acordeon-cabecera" (click)="alternar('experiencia')" [attr.aria-expanded]="estaAbierto('experiencia')">
      <span>Experiencia laboral</span>
      <span class="acordeon-icono" aria-hidden="true"></span>
    </button>
    <div class="acordeon-cuerpo" *ngIf="estaAbierto('experiencia')">
      <div class="perfil-grid">
        <label>
          Institución / Organización <span class="required-mark">*</span>
          <select [(ngModel)]="formularioCv.experiencia.institucion">
            <option value="">Seleccionar</option>
            <option *ngFor="let item of catalogoConValor(instituciones, formularioCv.experiencia.institucion)" [value]="item">{{ item }}</option>
          </select>
        </label>
        <label>
          Cargo / Posición <span class="required-mark">*</span>
          <input type="text" [(ngModel)]="formularioCv.experiencia.cargo" placeholder="Texto de ejemplo" />
        </label>
        <label>
          Experiencia vigente <span class="required-mark">*</span>
          <select [(ngModel)]="formularioCv.experiencia.experienciaVigente">
            <option value="">Seleccionar</option>
            <option *ngFor="let item of experienciaVigente" [value]="item">{{ item }}</option>
          </select>
        </label>
        <div class="fechas-par">
          <label>
            Fecha de inicio <span class="required-mark">*</span>
            <input type="date" [(ngModel)]="formularioCv.experiencia.fechaInicio" />
          </label>
          <label>
            Fecha de término
            <input type="date" [(ngModel)]="formularioCv.experiencia.fechaTermino" />
          </label>
        </div>
        <label class="full-row">
          Descripción / Funciones
          <textarea rows="3" [(ngModel)]="formularioCv.experiencia.funcionesPrincipales" placeholder="Ingresar detalle"></textarea>
          <small class="field-help">Opcional, Ingrese detalles de ámbito o funciones principales</small>
        </label>
      </div>
      <p class="cv-lista-titulo" *ngIf="cvData.experiencia.length">Registros en este bloque</p>
      <ul class="cv-lista" *ngIf="cvData.experiencia.length">
        <li *ngFor="let item of cvData.experiencia; let i = index">
          <span>{{ resumenExperiencia(item) }}</span>
          <span class="cv-lista-acciones">
            <button type="button" class="btn-mini-link" (click)="editarRegistro('experiencia', i)">Editar</button>
            <button type="button" class="btn-mini-link" (click)="eliminarRegistro('experiencia', i)">Eliminar</button>
          </span>
        </li>
      </ul>
      <div class="acordeon-acciones split">
        <div class="acciones-izquierda">
          <button type="button" class="btn-texto" (click)="editarRegistro('experiencia')">Editar <span class="btn-plus" aria-hidden="true">+</span></button>
          <button type="button" class="btn-texto" (click)="eliminarRegistro('experiencia')">Eliminar <span class="btn-plus" aria-hidden="true">+</span></button>
        </div>
        <button type="button" class="btn-agregar" (click)="agregarRegistro('experiencia')">{{ etiquetaAgregar('experiencia') }} <span class="btn-plus" aria-hidden="true">+</span></button>
      </div>
    </div>
  </article>

  <article class="acordeon" [class.abierto]="estaAbierto('proyectos')">
    <button type="button" class="acordeon-cabecera" (click)="alternar('proyectos')" [attr.aria-expanded]="estaAbierto('proyectos')">
      <span>Proyectos</span>
      <span class="acordeon-icono" aria-hidden="true"></span>
    </button>
    <div class="acordeon-cuerpo" *ngIf="estaAbierto('proyectos')">
      <div class="perfil-grid">
        <label>
          Nombre del proyecto <span class="required-mark">*</span>
          <input type="text" [(ngModel)]="formularioCv.proyectos.nombreProyecto" placeholder="Texto de ejemplo" />
        </label>
        <label>
          Código / Folio
          <input type="text" [(ngModel)]="formularioCv.proyectos.codigoFolio" placeholder="Texto de ejemplo" />
        </label>
        <label>
          Fuente de financiamiento <span class="required-mark">*</span>
          <select [(ngModel)]="formularioCv.proyectos.fuenteFinanciamiento">
            <option value="">Seleccionar</option>
            <option *ngFor="let item of catalogoConValor(fuentesFinanciamiento, formularioCv.proyectos.fuenteFinanciamiento)" [value]="item">{{ item }}</option>
          </select>
        </label>
        <label>
          Rol / Participación <span class="required-mark">*</span>
          <select [(ngModel)]="formularioCv.proyectos.rol">
            <option value="">Seleccionar</option>
            <option *ngFor="let item of catalogoConValor(rolesProyecto, formularioCv.proyectos.rol)" [value]="item">{{ item }}</option>
          </select>
        </label>
        <div class="fechas-par full-row">
          <label>
            Fecha de inicio <span class="required-mark">*</span>
            <input type="date" [(ngModel)]="formularioCv.proyectos.fechaInicio" />
          </label>
          <label>
            Fecha de término
            <input type="date" [(ngModel)]="formularioCv.proyectos.fechaTermino" />
          </label>
        </div>
      </div>
      <p class="cv-lista-titulo" *ngIf="cvData.proyectos.length">Registros en este bloque</p>
      <ul class="cv-lista" *ngIf="cvData.proyectos.length">
        <li *ngFor="let item of cvData.proyectos; let i = index">
          <span>{{ resumenProyecto(item) }}</span>
          <span class="cv-lista-acciones">
            <button type="button" class="btn-mini-link" (click)="editarRegistro('proyectos', i)">Editar</button>
            <button type="button" class="btn-mini-link" (click)="eliminarRegistro('proyectos', i)">Eliminar</button>
          </span>
        </li>
      </ul>
      <div class="acordeon-acciones split">
        <div class="acciones-izquierda">
          <button type="button" class="btn-texto" (click)="editarRegistro('proyectos')">Editar <span class="btn-plus" aria-hidden="true">+</span></button>
          <button type="button" class="btn-texto" (click)="eliminarRegistro('proyectos')">Eliminar <span class="btn-plus" aria-hidden="true">+</span></button>
        </div>
        <button type="button" class="btn-agregar" (click)="agregarRegistro('proyectos')">{{ etiquetaAgregar('proyectos') }} <span class="btn-plus" aria-hidden="true">+</span></button>
      </div>
    </div>
  </article>

  <article class="acordeon" [class.abierto]="estaAbierto('publicaciones')">
    <button type="button" class="acordeon-cabecera" (click)="alternar('publicaciones')" [attr.aria-expanded]="estaAbierto('publicaciones')">
      <span>Publicaciones y Producción</span>
      <span class="acordeon-icono" aria-hidden="true"></span>
    </button>
    <div class="acordeon-cuerpo" *ngIf="estaAbierto('publicaciones')">
      <div class="perfil-grid">
        <label>
          Tipo de publicación / producción <span class="required-mark">*</span>
          <select [(ngModel)]="formularioCv.publicaciones.tipo">
            <option value="">Seleccionar</option>
            <option *ngFor="let item of catalogoConValor(tiposPublicacion, formularioCv.publicaciones.tipo)" [value]="item">{{ item }}</option>
          </select>
        </label>
        <label>
          Título <span class="required-mark">*</span>
          <input type="text" [(ngModel)]="formularioCv.publicaciones.titulo" placeholder="Texto de ejemplo" />
        </label>
        <label>
          Estructura de Autores <span class="required-mark">*</span>
          <select [(ngModel)]="formularioCv.publicaciones.estructuraAutores">
            <option value="">Seleccionar</option>
            <option *ngFor="let item of catalogoConValor(estructurasAutores, formularioCv.publicaciones.estructuraAutores)" [value]="item">{{ item }}</option>
          </select>
        </label>
        <label>
          Revista / Editorial / Evento:
          <input type="text" [(ngModel)]="formularioCv.publicaciones.revistaEditorial" placeholder="Texto de ejemplo" />
        </label>
        <label>
          DOI / Enlace <span class="required-mark">*</span>
          <input type="text" [(ngModel)]="formularioCv.publicaciones.doiEnlace" placeholder="Texto de ejemplo" />
        </label>
        <label>
          Año / Fecha <span class="required-mark">*</span>
          <input type="date" [(ngModel)]="formularioCv.publicaciones.fecha" />
        </label>
      </div>
      <p class="cv-lista-titulo" *ngIf="cvData.publicaciones.length">Registros en este bloque</p>
      <ul class="cv-lista" *ngIf="cvData.publicaciones.length">
        <li *ngFor="let item of cvData.publicaciones; let i = index">
          <span>{{ resumenPublicacion(item) }}</span>
          <span class="cv-lista-acciones">
            <button type="button" class="btn-mini-link" (click)="editarRegistro('publicaciones', i)">Editar</button>
            <button type="button" class="btn-mini-link" (click)="eliminarRegistro('publicaciones', i)">Eliminar</button>
          </span>
        </li>
      </ul>
      <div class="acordeon-acciones split">
        <div class="acciones-izquierda">
          <button type="button" class="btn-texto" (click)="editarRegistro('publicaciones')">Editar <span class="btn-plus" aria-hidden="true">+</span></button>
          <button type="button" class="btn-texto" (click)="eliminarRegistro('publicaciones')">Eliminar <span class="btn-plus" aria-hidden="true">+</span></button>
        </div>
        <button type="button" class="btn-agregar" (click)="agregarRegistro('publicaciones')">{{ etiquetaAgregar('publicaciones') }} <span class="btn-plus" aria-hidden="true">+</span></button>
      </div>
    </div>
  </article>

  <article class="acordeon" [class.abierto]="estaAbierto('reconocimientos')">
    <button type="button" class="acordeon-cabecera" (click)="alternar('reconocimientos')" [attr.aria-expanded]="estaAbierto('reconocimientos')">
      <span>Reconocimientos y Premios</span>
      <span class="acordeon-icono" aria-hidden="true"></span>
    </button>
    <div class="acordeon-cuerpo" *ngIf="estaAbierto('reconocimientos')">
      <div class="perfil-grid">
        <label>
          Nombre del reconocimiento / premio <span class="required-mark">*</span>
          <select [(ngModel)]="formularioCv.distinciones.nombreReconocimiento">
            <option value="">Seleccionar</option>
            <option *ngFor="let item of catalogoConValor(nombresReconocimiento, formularioCv.distinciones.nombreReconocimiento)" [value]="item">{{ item }}</option>
          </select>
        </label>
        <label>
          Institución otorgante <span class="required-mark">*</span>
          <input type="text" [(ngModel)]="formularioCv.distinciones.institucionOtorga" placeholder="Texto de ejemplo" />
        </label>
        <label>
          Enlace de respaldo
          <input type="text" [(ngModel)]="formularioCv.distinciones.enlaceRespaldo" placeholder="Texto de ejemplo" />
        </label>
        <label>
          Año <span class="required-mark">*</span>
          <input type="date" [(ngModel)]="formularioCv.distinciones.fecha" />
        </label>
        <label class="full-row">
          Descripción / Funciones
          <textarea rows="3" [(ngModel)]="formularioCv.distinciones.descripcion" placeholder="Ingresar detalle"></textarea>
          <small class="field-help">Opcional, Ingrese detalles descriptivo o contexto del premio</small>
        </label>
      </div>
      <p class="cv-lista-titulo" *ngIf="cvData.distinciones.length">Registros en este bloque</p>
      <ul class="cv-lista" *ngIf="cvData.distinciones.length">
        <li *ngFor="let item of cvData.distinciones; let i = index">
          <span>{{ resumenReconocimiento(item) }}</span>
          <span class="cv-lista-acciones">
            <button type="button" class="btn-mini-link" (click)="editarRegistro('reconocimientos', i)">Editar</button>
            <button type="button" class="btn-mini-link" (click)="eliminarRegistro('reconocimientos', i)">Eliminar</button>
          </span>
        </li>
      </ul>
      <div class="acordeon-acciones split">
        <div class="acciones-izquierda">
          <button type="button" class="btn-texto" (click)="editarRegistro('reconocimientos')">Editar <span class="btn-plus" aria-hidden="true">+</span></button>
          <button type="button" class="btn-texto" (click)="eliminarRegistro('reconocimientos')">Eliminar <span class="btn-plus" aria-hidden="true">+</span></button>
        </div>
        <button type="button" class="btn-agregar" (click)="agregarRegistro('reconocimientos')">{{ etiquetaAgregar('reconocimientos') }} <span class="btn-plus" aria-hidden="true">+</span></button>
      </div>
    </div>
  </article>

  <div class="cv-generar">
    <button type="button" class="btn-agregar" (click)="abrirModalCurriculum()">
      Generar Curriculum <span class="btn-plus" aria-hidden="true">+</span>
    </button>
  </div>
</section>

<div class="cv-modal-backdrop" *ngIf="modalCurriculumVisible" (click)="cerrarModalCurriculum()">
  <div
    class="cv-modal"
    role="dialog"
    aria-modal="true"
    aria-labelledby="cv-modal-titulo"
    (click)="$event.stopPropagation(); menuDescargaVisible = false"
  >
    <header class="cv-modal-header">
      <h2 id="cv-modal-titulo">
        <span class="cv-modal-check" aria-hidden="true"></span>
        Mi currículum
      </h2>
      <button type="button" class="cv-modal-cerrar" (click)="cerrarModalCurriculum()" aria-label="Cerrar">×</button>
    </header>

    <div class="cv-modal-cuerpo">
      <article class="cv-modal-bloque" *ngFor="let bloque of vistaCurriculum">
        <h3>{{ bloque.titulo }}</h3>
        <p class="cv-modal-vacio" *ngIf="!bloque.registros.length">Sin registros en este bloque.</p>
        <div class="cv-modal-registro" *ngFor="let registro of bloque.registros">
          <p *ngFor="let campo of registro">
            <strong>{{ campo.etiqueta }}<span class="required-mark" *ngIf="campo.obligatorio"> *</span>:</strong>
            {{ campo.valor }}
          </p>
        </div>
      </article>
    </div>

    <footer class="cv-modal-footer">
      <div class="cv-descarga-wrap" (click)="$event.stopPropagation()">
        <div class="cv-descarga-menu" *ngIf="menuDescargaVisible">
          <button type="button" (click)="descargarCurriculum('pdf')">PDF</button>
          <button type="button" (click)="descargarCurriculum('word')">Word</button>
        </div>
        <button type="button" class="btn-agregar" (click)="alternarMenuDescarga($event)">
          Descargar <span class="btn-plus" aria-hidden="true">+</span>
        </button>
      </div>
    </footer>
  </div>
</div>
